import { usePutApplicationApplicantDetailsQuery } from "@lending/hooks/queries/ApplicationApplicantDetails/usePutApplicationApplicantDetailsQuery";
import { useFlowNavigation } from "@lending/navigation";
import { useStore } from "../../../contexts/StoreContext";
import type { PersonalInfoApiData } from "./types";

function useHandleUpdate() {
  const { goNext } = useFlowNavigation();
  const { data: storeData, updateData: updateStoreData } = useStore();

  const updateApplicationApplicantDetails = usePutApplicationApplicantDetailsQuery({
    onSuccess: () => {
      goNext();
    },
  });

  async function handleUpdate(data: PersonalInfoApiData, applicant_id: string) {
    const lendingApplicationID = storeData.lendingApplicationID ?? "";

    // Failures propagate to the caller, which surfaces field errors or a toast.
    await updateApplicationApplicantDetails.mutateAsync({
      params: {
        path: {
          uuid: applicant_id,
        },
      },
      body: {
        // TODO look into why application is needed here.
        // surely we should't be allowing an applicant to update the application they're associated with?
        application: lendingApplicationID,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone: data.phone,
      },
    });

    updateStoreData({
      date_of_birth: data.date_of_birth,
    });
  }

  return { handleUpdate };
}

export { useHandleUpdate };
